import { getEvidenceRigor } from '@/lib/filters';

export default function StatsBar({ papers }) {
  const totalPapers = papers.length;

  const totalArtifacts = papers.reduce((sum, p) => sum + (p.contribution?.artifacts?.length || 0), 0);

  const pctOf = (predicate) =>
    totalPapers ? Math.round((papers.filter(predicate).length / totalPapers) * 100) : 0;

  const pctWithImplementation = pctOf((p) =>
    (p.contribution?.artifacts || []).some((a) => a.implementation?.existence)
  );
  const pctRealWorldData = pctOf((p) =>
    (p.contribution?.artifacts || []).some((a) => a.data_collection?.data_type?.includes('real_world_data'))
  );
  const pctMature = pctOf((p) => getEvidenceRigor(p) === 'mature');

  const years = papers.map((p) => p.metadata?.year).filter(Boolean);
  const yearRange = years.length ? `${Math.min(...years)}–${Math.max(...years)}` : '—';

  const stats = [
    { label: 'Number of Artifacts', value: totalArtifacts },
    { label: '% With Implementation', value: `${pctWithImplementation}%` },
    { label: '% Real World Data', value: `${pctRealWorldData}%` },
    { label: '% Maturity Evidence', value: `${pctMature}%` },
    { label: 'Year Range', value: yearRange },
  ];

  return (
    <div className="stats-bar">
      {stats.map((s) => (
        <div className="stats-bar__tile" key={s.label}>
          <span className="stats-bar__value">{s.value}</span>
          <span className="stats-bar__label">{s.label}</span>
        </div>
      ))}
    </div>
  );
}
